import { useTranslation } from "react-i18next";
import { Fragment, useEffect, useState } from "react";
import { getDisplayDatetime } from "../../helpers/display_help";
import { Button, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAdminCompanyDeviceUpdateForIssue, updateAdminCompanyDeviceIssueStatus } from "../../slices/admin/thunk";
import AdminDeviceRecordRow from "./AdminDeviceRecordRow";
import { ISSUE_STATUS } from "../../common/constants";

function AdminDeviceIssueRow(props) {
    console.log("AdminDeviceIssueRow rendered");
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const data = useSelector(state => state.Admin.data.issues[props.data]);
    console.log(data);
    const updates = useSelector(state => state.Admin.data.updates);

    const [isCollapse, setCollapse] = useState(true);

    useEffect(() => {
        dispatch(getAdminCompanyDeviceUpdateForIssue(data["id"]));
    }, [isCollapse]);

    return (
        <Fragment>
            <tr 
                onClick={() => {
                    setCollapse(!isCollapse);
                }}>
                <td className="fw-medium collapse-icon">{isCollapse ? <i className="bx bxs-plus-square"></i> : <i className="bx bxs-minus-square"></i>}</td>
                <td style={{ width: 40 }} className="fw-medium">{data["id"]}</td>
                <td style={{ width: 40 }} className="fw-medium">{data["admin_device_id"]}</td>
                <td style={{ width: 40 }} className="fw-medium">{data["device"]["monitor_location_device_id"]}</td>
                <td style={{ width: 200 }}>{data["device"]["admin_company"]["name"]}</td>
                <td style={{ width: 200 }}>{getDisplayDatetime(data["created_at_epoch"] * 1000)}</td>
                <td style={{ width: 100 }}>{t(`PageAdmin.DeviceIssueStatus.${data["status"]}`)}</td>
                <td>
                    <textarea
                        value={data["first_update_info"] || ""}
                        readOnly
                        style={{
                            width: '100%',
                            minHeight: '2.25rem',
                            resize: 'vertical',
                            border: 'none',
                            background: 'transparent',
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                            padding: 0,
                            outline: 'none',
                            overflow: 'auto'
                        }}
                    />
                </td>
                <td>
                    {data["status"] === ISSUE_STATUS.OPEN && <Button className="btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={(e) => { e.stopPropagation(); props.setOpenCreateUpdateModal(data["device"]["monitor_location_device_id"], data["id"]);}}>{t('PageAdmin.Btn.CreateDeviceIssueUpdate')}</Button>}
                    {data["status"] === ISSUE_STATUS.OPEN && 
                    <Button className="btn-sm btn-primary" style={{ marginLeft: "10px" }} onClick={(e) => { e.stopPropagation(); dispatch(updateAdminCompanyDeviceIssueStatus(data["id"], ISSUE_STATUS.CLOSED)).then(() => { props.fetchData(); });}}>{t('PageAdmin.Btn.CloseDeviceIssue')}</Button>}
                </td>
                
            </tr>
            {isCollapse ? null : (
                <tr>
                    <td></td>
                    <td colSpan="9">
                        <Table className="table-nowrap mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.LastUpdatedAt')}</th>
                                    <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.Info')}</th>
                                    <th scope="col">{t('PageAdmin.CompanyDeviceRecordTable.Photo')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data['updates'] && data['updates'].map(i => {
                                    let d = updates[i];
                                    return (
                                        <AdminDeviceRecordRow
                                            data={d}
                                            key={d.id}
                                            isIssueUpdate={true}
                                        />
                                    );
                                })}
                            </tbody>
                        </Table>
                    </td>
                </tr>
            )}
        </Fragment>
    );
}

export default AdminDeviceIssueRow;
